/**
 * The featured promo package (admin "Featured Promo Package") in the new look's banner style - the
 * same shape as the high-probability banner below it, in gold. Presentational only: the app works
 * out the package, whether to show it and what buying it does, and passes them in.
 */
export function PromoBanner({
  name,
  kind,
  price,
  priceNote,
  description,
  cta = 'Purchase now',
  busy = false,
  onBuy,
}: {
  name: string;
  /** e.g. "One-off package" or "Subscription" */
  kind: string;
  price: string;
  /** e.g. "1 day access" or "/week" */
  priceNote?: string;
  description?: string;
  cta?: string;
  busy?: boolean;
  onBuy: () => void;
}) {
  return (
    <section className="ui-promo" aria-label={name}>
      <span className="ic" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 7l4.5 4L12 4l4.5 7L21 7l-2 11H5L3 7Zm2 13h14v2H5v-2Z" />
        </svg>
      </span>
      <span className="tx">
        <span className="hd">
          <b>{name}</b>
          <span className="pill">{kind}</span>
        </span>
        <span className="st">
          <span>
            <b>{price}</b>
            {priceNote && <span className="n"> {priceNote}</span>}
          </span>
          {description && <span className="ds">{description}</span>}
        </span>
      </span>
      <button type="button" className="go" onClick={onBuy} disabled={busy}>
        {busy ? 'Opening checkout…' : cta} <span aria-hidden="true">→</span>
      </button>
    </section>
  );
}
